var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opcAreaChat"},[_c('div',{staticClass:"regresarContenedor",on:{"click":function($event){return _vm.regresar()}}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',[_c('img',{attrs:{"src":require("../assets/images/regresar.svg"),"alt":""}})])
}]

export { render, staticRenderFns }